module.exports = __webpack_public_path__ + "static/img/bg-6.9c67cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-6.png
// module id = 4o20
// module chunks = 0